import {createRouter, createWebHistory} from "vue-router"
import HomePage from "@/pages/HomePage.vue";
import ProductPage from "@/pages/ProductPage.vue";
import WishlistPage from "@/pages/WishlistPage.vue";
import CartPage from "@/pages/CartPage.vue";

const routes = [
    {
        path: "/",
        name: "Home",
        component: HomePage,
    },
    {
        path: "/product",
        name: "Product",
        component: ProductPage,
    },
    {
        path: "/wishlist",
        name: "Wishlist",
        component: WishlistPage,
    },
    {
        path: "/cart",
        name: "Cart",
        component: CartPage,
    },
]

const router = createRouter({
    routes,
    history: createWebHistory()
    })

export default router;
